import { render } from "./iap-counter-badge.vue?vue&type=template&id=6a611c41&ts=true"
import script from "./iap-counter-badge.vue?vue&type=script&lang=ts"
export * from "./iap-counter-badge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__